import type {FC} from 'react';
import {Navigate, Outlet, useLocation} from 'react-router';

import {FoodDiaryOnboardingStore} from '@yourcoach/shared/modules/food-diary/stores/FoodDiaryOnboardingStore';
import {useMobxStore} from '@yourcoach/shared/utils/store';

import {MainMenuLayout, NotificationTopContainer} from '@src/layouts';
import TopMenu from '@src/modules/TopMenu/TopMenu';
import {routerPath} from '@src/routes/path';
import {GlobalStyles, Layout} from '@src/v2/pages/FoodDiaryPageLayout/styles';

export const FoodDiaryPageLayout: FC = () => {
  const foodDiaryOnboardingStore = useMobxStore(
    () => new FoodDiaryOnboardingStore(),
  );

  const location = useLocation();

  const shouldSkipRootCrumb =
    location.pathname === routerPath.foodDiary.$buildPath({});

  if (foodDiaryOnboardingStore.isOnboardingCompleted) {
    return (
      <Layout.Container>
        <GlobalStyles />
        <NotificationTopContainer />
        <Layout.Header>
          <TopMenu
            isWithCrumbs
            isWithFrom
            skipRootCrumb={shouldSkipRootCrumb}
          />
        </Layout.Header>
        <Layout.Menu>
          <MainMenuLayout />
        </Layout.Menu>
        <Layout.Content>
          <Outlet />
        </Layout.Content>
      </Layout.Container>
    );
  }

  return (
    <Navigate
      to={{
        pathname: routerPath.foodDiaryOnboarding.$buildPath({}),
      }}
    />
  );
};
